import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Handles sidebar and dark/light mode state.
 *
 * @returns {Object}  The store
 */
export const useUIStore = create(
  persist(
    (set, get) => ({
      isSidebarOpen: true,
      isMobile: undefined,
      toggleSidebar: () =>
        set(state => ({
          isSidebarOpen: !state.isSidebarOpen,
        })),
      setIsMobile: isMobile => set({ isMobile }),
      setSidebarOpen: open => set({ isSidebarOpen: open }),
      closeSidebarIfMobile: () => {
        const { isMobile, setSidebarOpen } = get()
        if (isMobile) {
          setTimeout(() => {
            setSidebarOpen(false)
          }, 0)
        }
      },

      // Dark mode theme state
      theme: 'system', // 'light', 'dark', or 'system'
      setTheme: theme => set({ theme }),
    }),
    {
      name: 'ui-storage', // unique name for localStorage key
      partialize: state => ({
        theme: state.theme,
      }),
    },
  ),
)
